import styled from 'styled-components';
import React from 'react';
import { SectionParent } from '../../components/StyledComponents';

const SectionOne = styled(SectionParent)`
  background-color: #f9f9fb;
  padding-bottom: 5rem;
  padding-top: 10rem !important;
  text-align: center;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;
const TableContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  margin-top: -6rem;
  width: 80%;
  max-width: 850px;
  justify-self: center;
  @media (max-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
    margin-top: -8rem;
    width: 100%;
  }
  @media (max-width: 550px) {
    margin-top: 0rem;
  }
`;

const RowContainer = styled.div`
  display: flex;
  grid-column: span 9;
  margin-bottom: 0.5rem;
  position: relative;
  height: fit-content;
`;
const RowLeft = styled.div`
  grid-column: span 1;
  height: 100%;
  text-align: left;
  padding: 0.5rem 0;
  padding-left: 1rem;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  display: grid;
  align-items: center;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;
const DetailsLeft = styled(RowLeft)`
  color: #000f16;
  padding: 0;
  padding: 0.5rem 0;
  padding-left: 1rem;
  text-transform: uppercase;
  align-items: flex-start;
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  border: solid 1px #627681;
`;
const RowRight = styled.div`
  height: 100%;
  padding: 0.5rem 0;
  grid-column: span 2;
  color: #ffffff;
  border: solid 1px #627681;
  text-align: left;
  display: grid;
  align-items: center;
  padding-left: 1rem;
  border-bottom: none;
  border-left: none;
`;
const DetailsRight = styled(RowRight)`
  color: #000f16;
  padding: 0;
  padding-top: 0rem;
  font-weight: normal;
  font-family: 'Nunito Sans', sans-serif;
`;
const Details = styled.div`
  display: flex;
  border-bottom: solid 1px #627681;
  padding: 0.5rem 0;
  padding-left: 1rem;
`;
const DetailsRightBold = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  color: #172b4d;
  width: 100%;
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;
const RowGrid = styled.div`
  grid-template-columns: repeat(3, 1fr);
  display: grid;
  width: 100%;
`;

export default (props: any) => {
  const data = props.hardware.data;
  return (
    <SectionOne>
      <TableContainer>
        <RowContainer>
          <RowGrid>
            <RowLeft style={{ background: '#1b2341' }}>Features</RowLeft>
            <RowRight style={{ background: '#4d5471' }}>Description</RowRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>display</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.display
                    ? data?.display?.[0]?.data?.Name === null
                      ? 'Not available'
                      : data?.display[0]?.data?.Name
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>camera</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {/* {data.Camera
                      ? data?.Camera?.map((item: any, index: number) =>
                          item === null
                            ? 'Not available'
                            : `${item}${
                                index + 1 === data.Camera.length ? `` : `, `
                              }`
                        )
                      : 'Not available'} */}

                  {data.Camera
                    ? data?.Camera?.map(
                        (item: any, index: number) =>
                          `${item?.data?.Name} ${
                            index < data.Camera.length - 1 ? ',\u00A0' : ''
                          }`
                      )
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>model</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {/* {data.Model
                      ? data?.Model[0] === null
                        ? 'Not available'
                        : data?.Model[0]
                      : 'Not available'} */}
                  {data.Model
                    ? data?.Model?.map(
                        (item: any, index: number) => `${item?.data?.Name}`
                      )
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>processor</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.Processor
                    ? data?.Processor === null
                      ? 'Not available'
                      : data?.Processor
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>ports</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.Ports !== null
                    ? data?.Ports?.map(
                        (item: any, index: number) =>
                          `${item} ${
                            index < data.Ports.length - 1 ? ',\u00A0' : ''
                          }`
                      )
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>OS</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.OS
                    ? data?.OS?.map(
                        (item: any, index: number) =>
                          `${item?.data?.Name} ${
                            index < data.OS.length - 1 ? ',\u00A0' : ''
                          }`
                      )
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>Battery</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.Battery
                    ? data?.Battery?.map(
                        (item: any, index: number) =>
                          `${item?.data?.Name} ${
                            index < data.Battery.length - 1 ? ',\u00A0' : ''
                          }`
                      )
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>sensors</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.Sensors
                    ? data?.Sensors?.map(
                        (item: any, index: number) =>
                          `${item?.data?.Name} ${
                            index < data.Sensors.length - 1 ? ',\u00A0' : ''
                          }`
                      )
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>bluetooth</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data?.bluetooth === null ? 'Not available' : data.bluetooth}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>Wi-Fi</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data?.WiFi_Details === null
                    ? data?.WiFi
                      ? 'Available'
                      : 'Not available'
                    : data?.WiFi_Details}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>RAM</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.ram__GB_?.length > 0
                    ? data?.ram__GB_.join(', ')
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>ROM</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.rom__GB_?.length > 0
                    ? data?.rom__GB_.join(', ')
                    : 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>Cellular Details</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data?.Cellular_Details === null
                    ? 'Not available'
                    : data.Cellular_Details}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>Accessories</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data?.Accessories === null
                    ? 'Not available'
                    : data.Accessories}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>Audio/Video</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.Audio___Video ?? 'Not Available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>WEIGHT (IN GRAMS)</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.Weight__In_Grams_ ?? 'Not Available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>WARRANTY (IN YEARS)</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.Warranty__Years_ ?? 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
        <RowContainer>
          <RowGrid>
            <DetailsLeft>DIMENSIONS</DetailsLeft>
            <DetailsRight>
              <Details>
                <DetailsRightBold>
                  {data.Dimension__H_x_W_x_T__in_mm ?? 'Not available'}
                </DetailsRightBold>
              </Details>
            </DetailsRight>
          </RowGrid>
        </RowContainer>
      </TableContainer>
    </SectionOne>
  );
};
